/* eslint-disable no-console */
import jwtDecode from 'jwt-decode'
import moment from 'moment'
const cookieparser = require('cookieparser')

export function getUserFromCookie(req) {
  if (process.server && process.static) {
    return
  }
  if (!req.headers.cookie) {
    return
  }

  if (req.headers.cookie) {
    const parsed = cookieparser.parse(req.headers.cookie)
    const accessTokenCookie = parsed.access_token
    if (!accessTokenCookie || typeof accessTokenCookie !== 'string') {
      return
    }

    try {
      // console.log('accessTokenCookie', accessTokenCookie)
      const decodedToken = jwtDecode(accessTokenCookie)
      if (!decodedToken) {
        return
      }

      return decodedToken
    } catch (error) {
      console.log(
        'Error decoding JWT token in getUserFromCookie:',
        error.message
      )
    }
  }
}
export function getTokenFromCookie(req) {
  if (!req.headers.cookie) {
    return
  }

  if (req.headers.cookie) {
    const parsed = cookieparser.parse(req.headers.cookie)
    const accessTokenCookie = parsed.access_token
    if (!accessTokenCookie || typeof accessTokenCookie !== 'string') {
      return
    }
    return accessTokenCookie
  }
}
export function getTokenFromRequestCookie(req) {
  if (!req.headers.common.cookie) {
    return
  }

  if (req.headers.common.cookie) {
    const parsed = cookieparser.parse(req.headers.common.cookie)
    const accessTokenCookie = parsed.access_token
    if (!accessTokenCookie || typeof accessTokenCookie !== 'string') {
      return
    }
    return accessTokenCookie
  }
}

export function mapQuoteToApiFormat(quote, email) {
  // const currentEffectiveYear = new Date(quote.effectiveDate).getFullYear()
  // const currentEffectiveMonth = new Date(quote.effectiveDate).getMonth() + 1
  // const currentEffectiveDay = new Date(quote.effectiveDate).getDate()
  const _date = moment(quote.effectiveDate).format('YYYY-MM-DD') // `${currentEffectiveYear}-${currentEffectiveMonth < 10 ? '0' + currentEffectiveMonth : currentEffectiveMonth}-${currentEffectiveDay < 10 ? '0' + currentEffectiveDay : currentEffectiveDay}`

  // const birthYear = new Date(quote.userDetails.dateBirth).getFullYear()
  // const birthMonth = new Date(quote.userDetails.dateBirth).getMonth() + 1
  // const birthDay = new Date(quote.userDetails.dateBirth).getDate()
  const _dateBirth = quote.userDetails.dateBirth
    ? moment(quote.userDetails.dateBirth).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD') // `${currentEffectiveYear}-${currentEffectiveMonth < 10 ? '0' + currentEffectiveMonth : currentEffectiveMonth}-${currentEffectiveDay < 10 ? '0' + currentEffectiveDay : currentEffectiveDay}`  // `${birthYear}-${birthMonth < 10 ? '0' + birthMonth : birthMonth}-${birthDay < 10 ? '0' + birthDay : birthDay}`

  const bicycles = quote.bicycles
  const _bicycles = bicycles.map(({ id, ...bike }) => {
    return { ...bike, is_ebike: bike.isEbike }
  })

  return {
    id: quote.id,
    pid: quote.pid,
    age: quote.age,
    discount: quote.discount,
    discountCode: quote.discountCode,
    discountSlug: quote.discountSlug,
    partnerSlug: quote.partnerSlug,
    effective_date: _date,
    payment_type: quote.payment_type,
    policy_type: quote.policy_type,
    customer: {
      date_of_birth: _dateBirth,
      first_name: quote.userDetails.firstName,
      last_name: quote.userDetails.lastName,
      email: email || quote.userDetails.email,
      telephone: quote.userDetails.phone,
      address_house: quote.userDetails.house,
      address_street: quote.userDetails.street,
      address_city: quote.userDetails.city,
      address_county: quote.userDetails.county,
      address_postcode: quote.postcode,
      isSubscribed: quote.userDetails.isSubscribed,
    },
    bicycles: _bicycles,
    insurance_components: quote.insurance_components,
    hiplok: quote.hiplok,
    hiplokProducts: quote.hiplokProducts,
  }
}

export function mapApiFormatToQuote(quote) {
  // const today = new Date()
  const quoteDate = moment(quote.period.effective_date) // new Date(quote.period.effective_date.split('')[0])
  const _dateBirth = moment(quote.customer.date_of_birth).toDate() // new Date(quote.customer.date_of_birth)

  const bicycles = quote.coverage.bicycles || []
  const _bicycles = bicycles.map((bike) => {
    return {
      id: bike.dbid,
      make: bike.make,
      model: bike.model || '',
      isEbike: bike.is_ebike,
      value: bike.value,
      serialNumber: bike.serial_number || '',
      photos: bike.photos || [],
    }
  })

  // let _date = ''
  // if (moment(today) > moment(quoteDate)) {
  //   _date = today
  // } else {
  //   _date = quoteDate
  // }

  return {
    id: quote.code,
    code: quote.code,
    pid: quote.id,
    postcode: quote.customer.address_postcode || '',
    discount: quote.discount,
    discountCode: quote.discountCode || null,
    discountSlug: quote.discountSlug || null,
    partnerSlug: quote.partner_slug || null,
    age: quote.age,
    balance: quote.balance || {},
    origin: quote.origin || {},
    price: quote.price || {},
    bicycles: _bicycles,
    effectiveDate: quoteDate,
    period: quote.period || {},
    payment_type: quote.payment_type,
    policy_type: quote.policy_type,
    status: quote.status || 0,
    binder_id: quote.binder_id,
    payment_method: quote.payment_method,
    notifications: quote.notifications,
    fullCode: quote.full_code,
    insurance_components: {
      accessories_cover:
        quote.coverage.insurance_components.accessories_cover || 'none',
      loss_of_earnings:
        quote.coverage.insurance_components.loss_of_earnings || 'none',
      personal_injury:
        quote.coverage.insurance_components.personal_injury || 'none',
      public_liability:
        quote.coverage.insurance_components.public_liability || 'none',
      amateur_racing: quote.coverage.risk_factors.amateur_racing || 'none',
      worldwide_cover: quote.coverage.risk_factors.worldwide_cover || 'none',
    },
    userDetails: {
      firstName: quote.customer.first_name || '',
      lastName: quote.customer.last_name || '',
      email: quote.customer.email || '',
      phone: quote.customer.telephone || '',
      house: quote.customer.address_house || '',
      street: quote.customer.address_street || '',
      city: quote.customer.address_city || '',
      county: quote.customer.address_county || '',
      dateBirth: _dateBirth || '',
      isSubscribed: quote.customer.isSubscribed || false,
    },
    hiplok: quote.hiplok,
    hiplokProducts: {
      dx: {
        count: quote.hiplokProducts?.dx?.count ?? 0,
      },
      gold: {
        count: quote.hiplokProducts?.gold?.count ?? 0,
      },
      edx: {
        count: quote.hiplokProducts?.edx?.count ?? 0,
      },
    },
  }
}

export function resetQuote(quoteBefore) {
  let discount = 0
  let discountCode = 0
  let discountSlug = 0
  let partnerSlug = 0
  let partnerLabel = 0
  if (quoteBefore) {
    discount = quoteBefore.discount
    discountCode = quoteBefore.discountCode
    discountSlug = quoteBefore.discountSlug
    partnerSlug = quoteBefore.partnerSlug
    partnerLabel = quoteBefore.partnerLabel
  }
  return {
    postcode: '',
    age: '',
    discount,
    discountCode,
    discountSlug,
    partnerSlug,
    partnerLabel,
    bicycles: [],
    effectiveDate: moment(),
    payment_type: 'annually',
    policy_type: '',
    insurance_components: {
      accessories_cover: 'none',
      amateur_racing: 'none',
      loss_of_earnings: 'none',
      personal_injury: 'none',
      public_liability: 'none',
      worldwide_cover: 'none',
    },
    userDetails: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      house: '',
      street: '',
      city: '',
      county: '',
      dateBirth: null,
    },
  }
}

export function getUserFromSession(req) {
  console.log('[CHECK-AUTH] - checking if user is stored in session')
  return req.session ? req.session.userId : null
}

// A bike as the customer would name it: "Specialized Tarmac". The model is
// optional and the make can still be the placeholder 'default' on a quote
// that hasn't had one entered, so either half may be missing.
export function bikeName(bike) {
  if (!bike) return ''
  const make =
    bike.make && bike.make.toLowerCase() !== 'default' ? bike.make : ''
  return [make, bike.model].filter(Boolean).join(' ')
}

// is_ebike as a boolean. Form-encoded round trips can hand it back as the
// string 'true'/'false' or 1/0, and a bare truthiness check reads 'false'
// as an e-bike.
export function isEbike(bike) {
  const v = bike && (bike.is_ebike !== undefined ? bike.is_ebike : bike.isEbike)
  return v === true || v === 1 || v === 'true' || v === '1'
}

// The steps between "I want a quote" and "I've paid". These pages strip the
// site furniture — header CTA, footer — so nothing invites the customer back
// out of the funnel they're partway through.
const PURCHASE_FUNNEL_ROUTES = ['welcome-back', 'quote-setup', 'quote-preview']

export function isPurchaseFunnelPath(path) {
  return new RegExp(`^/(${PURCHASE_FUNNEL_ROUTES.join('|')})(/|$)`).test(
    path || ''
  )
}

export const TYPE = {
  EDIT: 'edit',
  MTA: 'mta',
  PAYMENT: 'payment',
  FREE: 'free',
}

export const MODAL_TYPE = {
  bike: 'Bike',
  postcode: 'Postcode',
  address: 'Address',
  phone: 'Telephone',
  accessories: 'Accessories',
  competitions: 'Competitions',
  'foreign-travel': 'Foreign Travel',
  'personal-cover': 'Personal Cover',
  'loss-earning': 'Loss of Earning',
  'public-liability': 'Public Liability',
}
export const FAQ_DATA = [
  {
    category: 'AboutPedalsureCyclingInsurance',
    title: 'About Pedalsure Cycling Insurance',
    id: 'About-Pedalsure-Cycling-Insurance',
    items: [
      {
        anchor: 'what-does-it-cover',
        title: 'What does Pedalsure cycling insurance cover?',
        value:
          "<p>Pedalsure is an annual policy made up of the cover you choose. Your Policy Schedule confirms exactly what you've bought.</p><p><strong>Cover for your bike</strong> comes in two types. Both include up to £500 towards hiring a replacement bike while an approved claim is settled.</p><ul><li><strong>Theft Only</strong> – covers your bike if it's stolen in the UK, the Channel Islands or the Isle of Man. The only extras you can add are Personal Accident, loss of earnings and Personal Liability.</li><li><strong>Theft and Accidental Damage</strong> (full cover) – also covers accidental and malicious damage. You can add any extra: Personal Accident, loss of earnings, Personal Liability, accessories and personal possessions, competition (racing) cover, and worldwide cover for 30 or 60 days a year.</li></ul><p><strong>The extras:</strong></p><ul><li><strong>Personal Accident</strong> – Bronze, Silver or Gold benefits if you're injured in an accident while riding, getting on or getting off your bike.</li><li><strong>Loss of earnings</strong> – a weekly benefit if an accident while riding stops you working.</li><li><strong>Personal Liability</strong> – cover if you become legally liable for injuring someone or damaging their property while riding.</li></ul><p>Your insured bikes stay covered when ridden by a family member who lives with you. Personal Accident and Personal Liability cover you, the named policyholder, only.</p>",
      },
      {
        anchor: 'theft-only-vs-theft-and-accidental-damage',
        title:
          "What's the difference between Theft Only and Theft and Accidental Damage?",
        value:
          "<p><strong>Theft Only</strong> covers only your bike, if it's stolen. It doesn't cover accessories, bike boxes or personal possessions, and the only extras you can add are Personal Accident, loss of earnings and Personal Liability. It also doesn't cover accidental or malicious damage, including damage caused during a theft or attempted theft.</p><p><strong>Theft and Accidental Damage</strong> covers theft, plus:</p><ul><li><strong>accidental damage</strong> – sudden, unforeseen and unintentional damage, for example in a crash; and</li><li><strong>malicious damage</strong> – damage someone else causes on purpose, such as vandalism.</li></ul><p>It also includes replacement bike hire if an airline delays your bike on the way to a destination outside the UK.</p><p>The cover type you choose applies to every bike and item on your policy, and your excess may be different for each cover type. Your Policy Schedule shows which one you have. If it doesn't state a cover type, Theft and Accidental Damage applies.</p>",
      },
      {
        anchor: 'who-provides-the-insurance',
        title: 'Who provides Pedalsure cycling insurance?',
        value:
          '<p>Your insurer is <strong>Dukes House Insurance Limited</strong>, registered in Guernsey (company no. 66539) and authorised and regulated by the Guernsey Financial Services Commission (registration no. 2522730).</p><p>Your policy is arranged and administered by <strong>Pedalsure No. 3 Limited</strong>, trading as Pedalsure, an Appointed Representative of Pro MGA Solutions Ltd, which is authorised and regulated by the Financial Conduct Authority (FRN 770419). Dukes House Insurance Limited and Pedalsure No. 3 Limited are under common ownership.</p><p>Pedalsure handles claims for your bike. Roger Rich and Co handles Personal Accident and Personal Liability claims.</p><p>Legal expenses cover is not part of the policy.</p>',
      },
      {
        anchor: 'fscs',
        title:
          'Is my policy protected by the Financial Services Compensation Scheme (FSCS)?',
        value:
          '<p>No. Dukes House Insurance Limited is not a member of the FSCS. If it were unable to meet its obligations to you, you would not be able to claim compensation from the FSCS.</p><p>Dukes House is regulated by the Guernsey Financial Services Commission and follows Guernsey\'s codes of conduct for insurers, which you can read at <a href="https://www.gfsc.gg" rel="noopener" target="_blank">www.gfsc.gg</a>.</p>',
      },
      {
        anchor: 'who-is-eligible',
        title: 'Who can buy Pedalsure cycling insurance?',
        value:
          "<p>When your policy starts, you must:</p><ul><li>be 16 or over;</li><li>live in the UK or the Isle of Man;</li><li>not have made more than two bike-related claims in the past year, or a single bike-related claim of more than £500;</li><li>not have had insurance declined, cancelled by an insurer or refused, or had special terms imposed;</li><li>have no unspent criminal convictions, other than motoring offences;</li><li>own the bike, or be legally responsible for it under a hire, salary sacrifice (cycle to work) or finance agreement;</li><li>have no existing damage to the bike or accessories; and</li><li>not use the bike for a profession, business or occupation (commuting is fine).</li></ul><p>If you don't meet these requirements there's no cover, unless we've agreed otherwise in writing. Tell us as soon as possible if anything changes.</p>",
      },
      {
        anchor: 'age',
        title: 'What age do I need to be to buy a policy?',
        value: '<p>You must be 16 or over when you buy your policy.</p>',
      },
      {
        anchor: 'cycle-to-work',
        title:
          'Am I covered if I bought my bike through a Cycle to Work scheme?',
        value:
          "<p>Yes. You can insure a bike you hold under a cycle to work (salary sacrifice), hire or finance agreement, as long as you're legally responsible for it. Your price and cover are the same as for any other bike.</p><p>If you claim, a copy of the agreement showing the bike and its value counts as your evidence of ownership.</p>",
      },
      {
        anchor: 'start-date',
        title: 'When will my policy start?',
        value:
          '<p>You can choose a start date up to one month after the day you buy. Cover begins on the start date shown on your Policy Schedule – not before – and lasts for 12 months.</p>',
      },
      {
        anchor: 'what-is-an-excess',
        title: 'What is an excess?',
        value:
          "<p>The excess is the amount you pay towards each claim for theft, accidental damage or malicious damage under The Bike section. If one claim involves more than one bike, an excess applies to each bike.</p><p>Personal Accident benefits have no excess, but loss of earnings isn't paid for the first 14 days you're unable to work (the 'excess period').</p>",
      },
      {
        anchor: 'how-much-is-the-excess',
        title: 'How much is the excess?',
        value:
          '<p>Your excess is shown in your quote and on your Policy Schedule. It may be different for Theft Only and Theft and Accidental Damage cover.</p>',
      },
      {
        anchor: 'live-outside-uk',
        title: 'I live outside the UK – can Pedalsure cover me?',
        value:
          '<p>You must live in the UK or the Isle of Man to buy a policy.</p>',
      },
      {
        anchor: 'previous-claims',
        title: "I've made a claim before – will this affect my cover?",
        value:
          "<p>You can't buy a policy if, in the past year, you've made more than two bike-related claims (of any value) or a single bike-related claim of more than £500.</p><p>You also can't buy a policy if you've ever had insurance declined, cancelled by an insurer or refused, or had special terms imposed.</p>",
      },
      {
        anchor: 'bike-not-new',
        title: "My bike isn't brand new – can I insure it?",
        value:
          "<p>Yes, as long as you own it and it has no existing damage when you buy your policy. Insure it for what it would cost to replace new today, because claims are settled new for old. The bike's replacement value must be at least £400.</p>",
      },
      {
        anchor: 'new-for-old',
        title: "What does 'new for old' mean?",
        value:
          "<p>If we replace your bike, or pay you the cost of replacing it, we use a new bike of the same make and model – or one of equivalent specification if that's not available. We don't deduct anything for wear and tear or depreciation.</p><p>The most we'll pay is your sum insured, less your excess. If you've insured your bike for less than its replacement value, we'll reduce the payment in proportion (see 'What is underinsurance?').</p>",
      },
      {
        anchor: 'business-use',
        title: 'Do you cover cycle couriers or business use?',
        value:
          '<p>No. There\'s no cover for any use connected with a profession, business or occupation – including courier and delivery work, hiring out your bike, or carrying paying passengers. Commuting to and from work is covered.</p><p>For a bespoke business policy, email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a>.</p>',
      },
      {
        anchor: 'how-much-to-insure',
        title: 'How much should I insure my bike for?',
        value:
          "<p>Insure each bike for what it would cost to replace it new today with the same make and model, or one of equivalent specification. Use the full retail price including VAT – not an end-of-season, sale or second-hand price.</p><ul><li><strong>Upgraded bikes:</strong> include essential parts you've added, such as wheels, groupsets and pedals.</li><li><strong>Accessories</strong> such as lights, computers and panniers aren't part of the bike. Cover them with the accessories and personal possessions option.</li><li><strong>Self-built bikes:</strong> use the total value of the parts, not your build time.</li></ul><p>Keep receipts for the bike and any upgraded parts – you'll need them to claim. At renewal we may increase your sum insured to reflect the current cost of replacing your bike new; you can ask us to change it.</p>",
      },
      {
        anchor: 'underinsurance',
        title: 'What is underinsurance?',
        value:
          "<p>You're underinsured if your sum insured is less than the cost of replacing your bike new. If you claim, we'll reduce the payment in proportion.</p><p>For example, if you insure your bike for 70% of its replacement value, we'll pay 70% of the claim, less your excess.</p>",
      },
      {
        anchor: 'maximum-value',
        title: "What's the maximum value bike you insure?",
        value:
          "<p>We cover bikes worth up to £15,000 each, up to five bikes, and up to £30,000 in total. Anything above these limits is only covered if we've agreed in writing and it's shown as an endorsement on your Policy Schedule.</p>",
      },
      {
        anchor: 'multiple-bikes',
        title: 'Can I insure more than one bike on one policy?',
        value:
          '<p>Yes – up to five bikes, worth up to £15,000 each and £30,000 in total. Keep in mind:</p><ul><li>your cover type (Theft Only or Theft and Accidental Damage) applies to every bike on the policy;</li><li>if one claim involves more than one bike, an excess applies to each bike; and</li><li>only one bike is covered while in or on a vehicle.</li></ul>',
      },
      {
        anchor: 'lend-or-hire',
        title: 'Am I covered if I lend or hire my bike to someone else?',
        value:
          "<p>No. There's no theft or accidental damage cover while your bike is being used, ridden, hired or loaned by anyone other than a family member. We also don't cover theft by anyone you've lent, hired or entrusted the bike to.</p><p>If you run a bike hire business, email <a href=\"mailto:cservice@pedalsure.com\">cservice@pedalsure.com</a>.</p>",
      },
      {
        anchor: 'family',
        title: 'Can I insure my family on my policy?',
        value:
          '<p>Your insured bikes are covered when ridden by a family member – your parent, spouse, partner, son, daughter, brother or sister – who lives permanently with you at your insured address.</p><p>Personal Accident and Personal Liability cover only you, the named policyholder. Family members who want this cover need their own policy.</p>',
      },
      {
        anchor: 'what-is-personal-liability',
        title: 'What is Personal Liability cover?',
        value:
          "<p>Personal Liability (sometimes called third-party or public liability) covers you if you become legally liable to pay compensation for accidentally injuring or killing someone, or damaging their property, while using a bike. The limit is shown on your Policy Schedule.</p><p>It doesn't cover liability:</p><ul><li>for injury to your family or employees, or damage to property belonging to, or in the care of, you, your family or employees;</li><li>arising from business use, competitions (unless you've added competition cover) or stunts;</li><li>arising from riding in the USA or Canada, or from court action outside the policy's territorial limits;</li><li>for punitive, exemplary or aggravated damages; or</li><li>caused by not maintaining your bike in line with the manufacturer's instructions.</li></ul><p><strong>Important:</strong> if you already have liability cover from another source – for example through a cycling club membership or your home insurance – this section won't pay.</p>",
      },
      {
        anchor: 'liability-only',
        title: 'Can I buy Personal Liability cover on its own?',
        value:
          '<p>Personal Liability is an add-on to your bike cover. You can add it by itself or together with Personal Accident (Bronze, Silver or Gold).</p>',
      },
      {
        anchor: 'personal-injury',
        title: 'Do you cover personal injury?',
        value:
          "<p>Yes, if you add Personal Accident cover. It pays benefits if you're injured in an accident while riding, getting on or getting off your bike, and the injury results in one of the listed outcomes within 12 months. Benefits include:</p><ul><li><strong>Accidental death and serious injury</strong> (such as loss of sight, limbs or permanent total disablement): up to £10,000 (Bronze), £25,000 (Silver) or £50,000 (Gold)</li><li><strong>Broken bones</strong> (skull, shoulder, arm or leg only): up to £2,000, depending on the bone and your level</li><li><strong>Physiotherapy:</strong> up to £500, £750 or £1,000</li><li><strong>Emergency dental treatment</strong> for pain relief, started within 48 hours: up to £500, £750 or £1,250</li><li><strong>Hospital stays:</strong> £50 for each 24 hours as an in-patient, for up to 30 days</li><li><strong>Out of pocket expenses:</strong> up to £200, £300 or £500</li><li><strong>Loss of earnings (optional):</strong> a weekly benefit up to the amount on your Policy Schedule, capped at 75% of your average weekly wage, for up to 52 weeks from the date of the accident, with nothing paid for the first 14 days.</li></ul><p>We pay only one of the death and serious-injury benefits for each accident. There's no cover for injuries linked to alcohol or non-prescribed drugs, pre-existing medical conditions, psychiatric conditions, stunts, professional racing (other than time trials), or competitions unless you've added competition cover. See the <a href=\"https://www.pedalsure.com/policy-information\">Policy Document</a> for the full table of benefits.</p><p>Add Personal Accident when you get a quote, or from your account dashboard if you're already a customer.</p>",
      },
      {
        anchor: 'riding-other-bikes',
        title: "Am I covered when riding someone else's bike?",
        value:
          '<ul><li><strong>The Bike:</strong> only bikes you own (or are legally responsible for) and that are listed on your Policy Schedule are covered for theft and damage.</li><li><strong>Personal Liability:</strong> covers you while using any bike.</li><li><strong>Personal Accident:</strong> covers you while riding your bike. If you regularly ride bikes you don\'t own, <a href="https://www.pedalsure.com/contact-us">contact us</a> to check your cover.</li></ul>',
      },
      {
        anchor: 'motorcycles-scooters',
        title: 'Do you cover motorcycles or scooters?',
        value:
          "<p>We cover pedal cycles – including tricycles, tandems, trailer cycles, cargo bikes and push scooters – and e-bikes that are legal 'electrically assisted pedal cycles'.</p><p>We don't cover motorcycles, mopeds, e-scooters, ePeds, iPeds or any cycle with a moped-like appearance, or any cycle that falls under the Road Traffic Act.</p>",
      },
    ],
  },
  {
    category: 'ManagingyourpolicywithPedalsure',
    title: 'Managing your policy with Pedalsure',
    id: 'ManagingyourpolicywithPedalsure',
    items: [
      {
        anchor: 'after-you-buy',
        title: 'What do I need to do after I buy my policy?',
        value:
          "<ul><li>Check your Policy Schedule is correct, including your cover type (Theft Only or Theft and Accidental Damage).</li><li><strong>Upload photos of each insured bike</strong> to your account within 30 days. If you don't, your cover may be invalid and we may cancel your policy.</li><li>Keep proof of ownership for your bikes, upgraded parts and lock, plus your lock keys.</li><li>Read the security requirements – we can't pay theft claims if they haven't been met.</li><li>Tell us as soon as possible if anything on your schedule is wrong or your circumstances change.</li></ul>",
      },
      {
        anchor: 'cancel',
        title: 'How do I cancel my policy?',
        value:
          '<p>Email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a>.</p><ul><li><strong>Within 14 days</strong> of buying your policy or receiving your documents (whichever is later): you\'ll get a full refund, as long as no claims have been made or are pending.</li><li><strong>After 14 days:</strong> you\'ll get a refund for the remaining period of insurance, less an administration fee of up to £20, as long as no claims have been made or are pending.</li></ul><p>If you received a gift with your policy, such as a free lock, we may reduce your refund by its retail value.</p>',
      },
      {
        anchor: 'make-changes',
        title: 'How do I make changes to my cover?',
        value:
          '<p>Log in to your account dashboard to add or remove a bike, change your cover type, or add or remove accessories, Personal Accident or Personal Liability cover. You can also email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a>.</p><p>Any extra premium is spread across your remaining monthly instalments, or due straight away if you\'ve already paid in full. Changes made by phone or post have a £10 administration fee.</p>',
      },
      {
        anchor: 'switch-cover-type',
        title: 'Can I switch from Theft Only to Theft and Accidental Damage?',
        value:
          "<p>Yes, at any time. Accidental and malicious damage cover starts <strong>14 days after</strong> the change takes effect, as shown on your updated Policy Schedule, and you only pay the extra premium from that date.</p><p>We don't cover damage that happened, or already existed, before your damage cover started. The same 14-day wait applies if you cancel a Theft Only policy and take out Theft and Accidental Damage cover for the same bike within 30 days.</p>",
      },
      {
        anchor: 'payment-method',
        title: 'Can I change the way I pay?',
        value:
          '<p>Yes. You can switch between monthly payments and a single annual payment. Email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a> and we\'ll make the change.</p>',
      },
      {
        anchor: 'payment-date',
        title: 'Can I change my payment date?',
        value:
          '<p>If you pay monthly, yes. Email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a> and we\'ll update it.</p>',
      },
      {
        anchor: 'moving-or-staying-away',
        title: 'Am I covered if I move house or stay somewhere else?',
        value:
          "<p>Your bike is covered at the address on your Policy Schedule. It's also covered at a temporary address, such as a holiday home, hotel or guest house, for up to 30 days at a time. The same security requirements apply wherever you are.</p><p>If you move, or will live somewhere else for more than 30 days, tell us first. If we agree to cover the new address, we'll confirm it with an endorsement to your policy.</p>",
      },
      {
        anchor: 'renewal',
        title: 'How does my policy renew?',
        value:
          "<p>Your policy lasts 12 months. If we can offer renewal, we'll email you 30 days before it ends with your renewal price and any changes to the terms.</p><p>We may increase your sum insured to reflect the current cost of replacing your bike new – your renewal email will show the new sum insured and price, and you can ask us to change it. Unless you cancel, your policy renews automatically and we'll send you a new Policy Schedule and Policy Document.</p>",
      },
      {
        anchor: 'cancel-renewal',
        title: 'How do I cancel my renewal?',
        value:
          '<p>Use the \'Cancel my renewal\' button in your renewal email, which we send 30 days before your policy ends. You can also email <a href="mailto:cservice@pedalsure.com">cservice@pedalsure.com</a>.</p>',
      },
      {
        anchor: 'renewal-price-increase',
        title: 'Why has my renewal price gone up?',
        value:
          "<p>We only change your price or terms at renewal, never part-way through the year. Your renewal price may be higher because:</p><ul><li>we've increased your sum insured to match the current cost of replacing your bike new;</li><li>you've made changes, such as moving address or adding cover; or</li><li>prices have gone up for all customers – for example after an unusually high number of claims.</li></ul><p>You can ask us to change your sum insured or cover before you renew.</p>",
      },
      {
        anchor: 'complaints',
        title: 'How do I make a complaint?',
        value:
          '<p><strong>About our service:</strong> email <a href="mailto:complaints@pedalsure.com">complaints@pedalsure.com</a>, call 0800 888 6745, or write to Complaints Department, Pedalsure No. 3 Limited, Suite 3 Dukes House, 4–6 High Street, Windsor SL4 1LD. If you haven\'t had a final response within 8 weeks, or you\'re unhappy with it, you can contact the <a href="https://www.financial-ombudsman.org.uk" rel="noopener" target="_blank">Financial Ombudsman Service</a>.</p><p><strong>About a claim or your policy terms:</strong> your complaint goes to the insurer, Dukes House Insurance Limited, Customer Relations Department, PO Box 155, Mill Court, La Charroterie, St Peter Port, Guernsey GY1 4ET. If you\'re unhappy with its final response, or it isn\'t resolved within 3 months, you can contact the <a href="https://www.ci-fo.org" rel="noopener" target="_blank">Channel Islands Financial Ombudsman</a>. You must contact them within 6 months of the final response, and within 6 months of the event you\'re complaining about (or, if later, 2 years from when you could reasonably have known you had reason to complain).</p><p>Please quote your policy number. This doesn\'t affect your legal rights.</p>',
      },
    ],
  },
  {
    category: 'Locks and security',
    title: 'Locks and security',
    id: 'Locks and security',
    items: [
      {
        anchor: 'lock-requirements',
        title: 'What lock do I need?',
        value:
          '<p>You must use an <strong>approved lock</strong> whenever the policy asks for one. That\'s a bicycle lock tested and approved by Sold Secure, or a Thatcham-approved motorcycle lock, rated for your bike\'s sum insured:</p><ul><li><strong>bikes insured for £1,000 or less:</strong> Sold Secure Silver, Gold or Diamond, or Thatcham-approved motorcycle lock;</li><li><strong>bikes insured for more than £1,000:</strong> Sold Secure Gold or Diamond, or Thatcham-approved motorcycle lock.</li></ul><p>You can check your lock\'s rating at <a href="https://www.soldsecure.com" target="_blank" rel="noopener">soldsecure.com</a>. We only accept other locks if we\'ve agreed to them in writing.</p><p>A cable supplied with or used alongside a lock doesn\'t count. Keep your lock keys and the receipt showing the lock\'s make and model – for a theft claim we\'ll need the key and receipt, or the remains of the lock. There\'s no cover if the key was left in or with the lock or bike, or the lock wasn\'t locked.</p><p>See our <a href="https://www.pedalsure.com/policy-information">Approved Lock List</a>. Customers can also get discounts on Hiplok locks – see our <a href="https://www.pedalsure.com/hiplok">Hiplok offer</a>.</p>',
      },
      {
        anchor: 'security-at-home',
        title: 'What security do I need at home?',
        value:
          "<p>Theft from home is only covered if the thief got in by force – leaving visible damage to the building, the lock or the object your bike was locked to. What else you need depends on where you keep your bike:</p><ul><li><strong>Inside your house, flat or a self-contained lockable room in private halls:</strong> no extra lock needed, as long as any security devices are working.</li><li><strong>In a private garage, shed or outbuilding:</strong> see 'Can I keep my bike in a shed or garage at home?'.</li><li><strong>In a communal hallway or communal outbuilding:</strong> locked through the frame to an immovable object with an approved lock.</li></ul><p>Your garden and driveway count as 'away from home' (see 'Can I leave my bike in the garden?'). There's no theft cover if your home has been unoccupied for more than 30 days in a row, and personal possessions and bike boxes aren't covered if stolen from home.</p>",
      },
      {
        anchor: 'garden',
        title: 'Can I leave my bike in the garden?',
        value:
          "<p>Your garden, driveway and any local bike hangar count as <strong>away from home</strong>. Your bike must be locked through the frame to an immovable object with an approved lock, and there's no theft, accidental damage or malicious damage cover if it's left there for more than 12 hours – even if it's locked.</p>",
      },
      {
        anchor: 'shed-or-garage',
        title: 'Can I keep my bike in a shed or garage at home?',
        value:
          "<p>Yes, if it's within the boundary of the private house you live in and privately accessed. Entry must be by force, and:</p><ul><li><strong>Approved shed</strong> (a metal bike shed with Secured by Design accreditation): no extra lock needed, as long as any security devices are working.</li><li><strong>Any other garage, shed or outbuilding:</strong><ul><li>any garage door must have Secured by Design accreditation;</li><li>every external door must be secured by a 5-lever mortice deadlock to BS3621, an approved lock, or a CEN 4 (or higher) rated padlock; and</li><li>your bike must be locked through the frame to an immovable object inside with an approved lock.</li></ul></li></ul>",
      },
      {
        anchor: 'away-from-home',
        title: 'How should I secure my bike away from home?',
        value:
          "<p>If your bike is unattended – not being used or held by you or an adult you've trusted with it – it must be:</p><ul><li>locked through the frame to an immovable object with an approved lock; and</li><li>left for no more than <strong>12 hours</strong>, or <strong>24 hours</strong> at your place of work or in a cycle rack at a railway station.</li></ul><p>For a theft claim, the thief must have forced the lock or the object it was locked to, leaving visible damage. Your bike is also covered when it's left in the transition area of an organised triathlon or duathlon you're taking part in.</p>",
      },
      {
        anchor: 'outside-overnight',
        title: 'Can I leave my bike outside overnight?',
        value:
          "<p>Only for up to 12 hours (24 hours at your workplace or in a railway station cycle rack), locked through the frame to an immovable object with an approved lock. This includes your own garden or driveway. After that, there's no theft, accidental damage or malicious damage cover, even if it's locked.</p>",
      },
      {
        anchor: 'at-work',
        title: 'Is my bike covered at work?',
        value:
          "<p>Yes, if it's locked through the frame to an immovable object with an approved lock and left for no more than 24 hours. For a theft claim, the thief must have forced the lock or the object it was locked to, leaving visible damage.</p>",
      },
      {
        anchor: 'in-a-vehicle',
        title: 'Can I leave my bike in or on a car or van?',
        value:
          "<p>Yes, but only <strong>one bike</strong> is covered while in or on a vehicle. Your bike must be either:</p><ul><li><strong>inside</strong> the vehicle, out of sight, with all doors, windows and openings closed and locked and any security devices switched on – and the thief must have got in by force; or</li><li><strong>on</strong> the vehicle, locked through the frame with an approved lock to a properly fixed roof rack or bike rack.</li></ul><p>Between 9pm and 6am, the vehicle must also have a Thatcham Category 1 alarm/immobiliser, Category 2 immobiliser or Category 3 steering lock. If a Category 1 or 2 device wasn't factory fitted, it must have been installed by a Vehicle Security Installation Board member, and you'll need proof if you claim. Outside the UK, the vehicle must have a factory-fitted alarm or immobiliser.</p><p>There's no theft or malicious damage cover while your bike is kept on a boat, narrowboat or other watercraft.</p>",
      },
      {
        anchor: 'immovable-object',
        title: 'What counts as an immovable object?',
        value:
          "<ul><li>A solid object fixed into or onto concrete or stone that can't be undone, removed, or lifted over or under your bike – such as a fixed bike stand or railing.</li><li>A properly fixed vehicle roof rack or bike rack.</li><li>A bike rack provided at a railway station for locking bikes, within the jurisdiction of the British Transport Police or equivalent.</li></ul>",
      },
      {
        anchor: 'security-requirement-not-met',
        title: "What if I didn't meet a security requirement?",
        value:
          "<p>We won't pay a claim if the security requirements weren't met. But we won't rely on a failure if you can show it couldn't have increased the risk of the loss or damage that happened, in the circumstances it happened.</p>",
      },
      {
        anchor: 'test-ride-or-sale',
        title: 'Am I covered if my bike is stolen during a test ride or sale?',
        value:
          "<p>No. We don't cover the loss of your bike if you, a family member or someone acting for you handed it over voluntarily – even if you were tricked. That includes test rides, sales arranged online or in person, and payments that turn out to be fake, are reversed or never arrive.</p>",
      },
    ],
  },
  {
    category: 'Travel',
    title: 'Travel',
    id: 'Travel',
    items: [
      {
        anchor: 'riding-abroad',
        title: 'Am I covered if I ride abroad?',
        value:
          "<p>Your policy covers you in the UK, the Channel Islands and the Isle of Man. To ride further afield, add worldwide cover for up to 30 or 60 days in each policy year.</p><p>Personal Liability doesn't cover anything arising from riding in the USA or Canada. If you leave your bike in or on a vehicle outside the UK, the vehicle must have a factory-fitted alarm or immobiliser.</p>",
      },
      {
        anchor: 'long-trip',
        title:
          "I'm going on a four-month cycling trip abroad – can you cover me?",
        value:
          "<p>Worldwide cover extends your policy abroad for up to 30 or 60 days in each policy year. We can't cover time abroad beyond 60 days.</p>",
      },
      {
        anchor: 'short-term',
        title: 'Can I buy a short-term policy for a two-week cycling trip?',
        value:
          '<p>No – our policies run for 12 months. For a one-off trip, a sports travel insurance policy may suit you better; these can include medical and repatriation costs and damage to sports equipment such as your bike.</p>',
      },
      {
        anchor: 'flying',
        title: 'Is my bike covered on a flight?',
        value:
          "<p>To be protected overseas, including on flights abroad, you need full cover: Theft and Accidental Damage with worldwide cover added. Theft Only doesn't cover your bike overseas at all.</p><p>With full cover, your bike is covered for theft and damage while the airline has it, as long as it's packed in a hard or rigid bike box and you get a luggage receipt from the airline. Fabric bike bags don't count. We'll also pay up to £500 for a replacement hire bike if the airline delays your bike on the way to a destination outside the UK.</p><p>Your bike box is only covered if your bike is stolen or damaged at the same time.</p>",
      },
      {
        anchor: 'couriers',
        title: 'Is my bike covered when I send it by courier?',
        value:
          "<p>No. There's no theft or damage cover while your bike is in transit with a courier, bike shipping company or other delivery service.</p>",
      },
    ],
  },
  {
    category: 'Activities',
    title: 'Activities',
    id: 'Activities',
    items: [
      {
        anchor: 'racing',
        title: 'Does the policy cover racing?',
        value:
          "<p>Yes, if you add competition cover. A competition is an organised cycling or triathlon event where a winner is selected. Without competition cover, there's no cover for accidents during a competition under any part of the policy.</p><p>Sportives and charity rides where no winner is selected don't need competition cover. Personal Accident doesn't cover professional racing, other than time trials.</p>",
      },
      {
        anchor: 'charity-rides',
        title: 'Am I covered for charity rides like London to Brighton?',
        value:
          "<p>Yes. Sportives and charity rides where no winner is selected don't need competition cover – you're covered under whichever sections of the policy you've bought.</p>",
      },
      {
        anchor: 'triathlons',
        title: 'Am I covered for triathlons?',
        value:
          "<p>Yes, if you add competition cover. With it, Personal Accident also covers you during the swim and run.</p><p>Your bike is covered while it's left in the transition area of an organised triathlon or duathlon you're taking part in.</p>",
      },
      {
        anchor: 'stunts',
        title: 'Am I covered for stunts or tricks?',
        value:
          "<p>No. There's no accidental damage, Personal Accident or Personal Liability cover while you're performing stunts or using equipment designed for stunts, such as ramps.</p>",
      },
    ],
  },
  {
    category: 'Bike types, parts and accessories',
    title: 'Bike types, parts and accessories',
    id: 'Bike types, parts and accessories',
    items: [
      {
        anchor: 'e-bikes',
        title: 'Do you cover electric bikes?',
        value:
          "<p>Yes, if your e-bike is legal on UK roads as an electrically assisted pedal cycle (EAPC) – broadly, a motor of no more than 250 watts that stops assisting above 15.5 mph. 'Twist and go' e-bikes are only covered if the throttle works in walk mode only.</p><p>A battery, charger or removable display stolen on its own is only covered if the bike was stolen at the same time, or the battery was locked to the bike with its built-in lock and there's visible evidence it was forced out.</p>",
      },
      {
        anchor: 'cargo-bikes',
        title: 'Do you cover cargo bikes?',
        value:
          "<p>Yes, including electric cargo bikes, as long as they're legal on UK roads as electrically assisted pedal cycles (EAPCs).</p>",
      },
      {
        anchor: 'proof-of-ownership',
        title: 'Do I need proof of ownership?',
        value:
          "<p>Yes. Upload photos of each insured bike to your account within 30 days of buying your policy – include the serial number if you can.</p><p>If you claim, we'll need evidence of ownership: ideally the original receipt showing the date, price, bike details and the seller's name and address. If you don't have it, other evidence that clearly shows you own the item and bought it may be accepted. For a bike held under a cycle to work, hire or finance agreement, send a copy of the agreement.</p><p>For a theft claim we'll also need your lock key and the lock's receipt, or the remains of the lock.</p>",
      },
      {
        anchor: 'gifted-bike',
        title: 'Can I insure a bike I was given as a gift?',
        value:
          "<p>Yes. You'll need evidence of ownership – ideally the original receipt (ask the person who gave it to you), or other evidence that clearly shows ownership and proof of purchase.</p>",
      },
      {
        anchor: 'self-built',
        title: 'I built my bike myself – can I insure it?',
        value:
          "<p>Yes. Insure it for the full retail cost of its parts new – not your build time. If we replace it, we'll use the same or equivalent frame and components. Keep the receipts for the frame, components and your lock. Photos help, but on their own may not be enough evidence of ownership.</p>",
      },
      {
        anchor: 'accessories-option',
        title:
          'What does the accessories and personal possessions option cover?',
        value:
          "<p>It covers, up to the limit on your Policy Schedule:</p><ul><li><strong>accessories</strong> – non-essential equipment fixed to the frame, such as panniers, GPS computers, saddlebags, mudguards, lights and trailers (including passenger trailers); and</li><li><strong>personal possessions</strong> – clothes and items worn, used or carried on the bike when you're away from home, such as your helmet, cycling or triathlon clothing and sports equipment.</li></ul><p>They're only covered if your bike is stolen at the same time – or, with Theft and Accidental Damage, damaged at the same time. Personal possessions aren't covered if stolen from your home. Valuables (such as phones, watches, cameras and jewellery) and money aren't covered.</p><p>Essential parts such as upgraded wheels or gears belong in your bike's sum insured, not here.</p>",
      },
      {
        anchor: 'valuables',
        title: 'Is my phone, watch or camera covered?',
        value:
          "<p>No. Valuables – including mobile phones, watches, cameras, binoculars, jewellery and MP3 players – and money aren't covered. A GPS bike computer fixed to your frame counts as an accessory and can be covered under the accessories option.</p>",
      },
      {
        anchor: 'racing-wheels',
        title: 'I have several sets of racing wheels – can I insure them?',
        value:
          "<p>Only the wheels included in your bike's sum insured are covered – spare wheelsets can't be insured separately. We suggest including your most expensive wheelset in your bike's sum insured.</p><p>Wheels are only covered for theft if they're locked to the frame or an immovable object with an approved lock, or stolen along with the bike. Keep the receipts – photos help, but on their own may not be enough evidence of ownership.</p>",
      },
      {
        anchor: 'trailers',
        title: 'Can I insure a child trailer?',
        value:
          "<p>Yes, as an accessory. Add the accessories and personal possessions option with a high enough limit to cover it. It's only covered if your bike is stolen (or, with Theft and Accidental Damage, damaged) at the same time. A trailer can't be insured as a separate item.</p>",
      },
    ],
  },
  {
    category: 'Claims',
    title: 'Claims',
    id: 'Claims',
    items: [
      {
        anchor: 'how-to-claim',
        title: 'How do I make a claim?',
        value:
          '<p>Log in to your account dashboard and follow the steps to make a claim. If you can\'t log in, email <a href="mailto:claims@pedalsure.com">claims@pedalsure.com</a> or call 0800 888 6745 (Monday to Friday, 9am–5pm). Calls may be recorded.</p><ul><li><strong>Theft or malicious damage:</strong> report it to the police as soon as possible and get a crime reference number.</li><li><strong>Bike claims:</strong> tell us within 30 days of discovering the theft or damage. A later claim may be reduced or refused if the delay affects our investigation.</li><li><strong>Injury:</strong> contact us as soon as possible, and within 28 days of the accident.</li></ul>',
      },
      {
        anchor: 'what-you-need',
        title: 'What will I need for my claim?',
        value:
          "<p>Depending on your claim, we may ask for:</p><ul><li>evidence of ownership for the bike and any items claimed;</li><li>a police crime reference number;</li><li>your lock key and the lock receipt, or the remains of the lock;</li><li>your airline luggage receipt, or proof of your vehicle's alarm or immobiliser; and</li><li>for injury claims, medical records – and you must follow your doctor's advice.</li></ul><p>Don't throw away damaged items, and don't admit liability to anyone who's holding you responsible – send us any letters or court papers straight away.</p>",
      },
      {
        anchor: 'claim-timescales',
        title: 'How long does a claim take?',
        value:
          "<p>We handle bike claims in-house and aim to review every new claim within 24 hours. Most are approved the same day or within 48 hours; complex claims that need more documents can take longer. Many claims are settled the day they're approved.</p>",
      },
      {
        anchor: 'repair-or-replace',
        title: 'Will you repair or replace my bike?',
        value:
          "<p>We decide whether to repair or replace your bike, or pay you the cost. Usually a specialist dealer we choose will assess it and repair or replace it, and invoice us directly. If we don't repair or replace it, we'll pay you in cash, less your excess.</p><p>We may keep any bike or item we've replaced. If you pay monthly, we may deduct the premium still due for the rest of your policy year from your claim payment.</p>",
      },
      {
        anchor: 'replacement-bike-hire',
        title: 'Can I hire a bike while I wait for my claim?',
        value:
          "<p>Yes. We'll pay up to £500 in each policy year towards hiring an equivalent bike from a reputable bike dealer while you wait for an approved claim to be settled. You must get approval from us before you hire, and keep your receipts.</p>",
      },
      {
        anchor: 'other-insurance',
        title: 'What if I have other insurance that covers the same thing?',
        value:
          "<p>If another policy or guarantee covers the same theft or damage, we'll pay a proportionate share of the claim. If your bike or item is specifically insured under another policy – for example, named on your home insurance – we won't cover it at all. Personal Liability doesn't pay at all if you're covered for the same liability elsewhere – for example through a cycling club or your home insurance.</p>",
      },
      {
        anchor: 'not-covered',
        title: "What isn't covered for my bike?",
        value:
          "<p>The main things we don't cover are:</p><ul><li>theft where you can't say when, where or how it happened, or items that are lost or go missing;</li><li>any damage if you have Theft Only;</li><li>scratches, dents and other cosmetic damage that doesn't affect how the bike works;</li><li>wear and tear, rust, mechanical or electrical breakdown, and damage from cleaning, maintenance or repairs;</li><li>damage from not using or maintaining the bike as the manufacturer instructs;</li><li>theft or damage where the security requirements weren't met;</li><li>damage that existed before your cover (or damage cover) started; and</li><li>bikes not listed on your Policy Schedule.</li></ul><p>See the <a href=\"https://www.pedalsure.com/policy-information\">Policy Document</a> for the full list.</p>",
      },
      {
        anchor: 'premium-after-claim',
        title: 'Will my premium go up if I claim?',
        value:
          "<p>We won't change your price part-way through the year because you've claimed. If we replace your bike or pay out your full sum insured, you can choose to reinstate cover for the replacement until your renewal date – there's an extra premium for this, and it's higher if the replacement is worth more.</p><p>After a claim, we may offer different terms at renewal, or decide not to renew.</p>",
      },
    ],
  },
]
